import { makeStyles } from "@saleor/macaw-ui";
const useStyles = makeStyles(
  theme => ({
    root: {
      borderRadius: 6,
      background: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      marginTop: "1.6rem"
    },
    info: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      marginLeft: "300px"
    },
    singleLineMessages: {
      whiteSpace: "nowrap",
      textAlign: "center",
      justifyContent: "space-between",
      alignItems: "center"
    },
    singletexts: {
      alignItems: "center",
      alignContent: "center"
    },
    priorityDivs: {
      display: "flex",
      gap: "40px"
    },
    priorityBox: {
      flexGrow: 1,
      maxWidth: "100%",
      flexBasis: "auto"
    },
    priorityLabel: {
      flexGrow: 0,
      maxWidth: "100px"
    },
    fontStyles: {
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#222222"
    },
    addingstylepriors: {
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    typo: {
      fontFamily: "SCG",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "18px",
      color: "#999999"
    },
    bottomBar: {
      padding: "2.4rem 2.4rem 2.4rem 0",
      display: "flex",
      justifyContent: "space-between"
    },
    header: {
      padding: "1rem 1.6rem",
      background: theme.palette.gardient.medium,
      colors: "white",
      display: "flex",
      alignItems: "center"
    },
    title: {
      color: "white",
      marginRight: "4px"
    },
    dragdrops: {
      display: "flex",
      position: "absolute",
      right: 0,
      top: 2,
      marginTop: "0px",
      alignItems: "center",
      marginLeft: "20px",
      borderLeft: "solid 1px #ccc",
      height: "100%"
    },
    dragIcons: {
      cursor: "pointer",
      zIndex: 2,
      padding: "10px",
      paddingRight: "20px"
    },
    diadrop: {
      display: "flex",
      position: "absolute",
      right: 0,
      top: 0,
      marginTop: "0px",
      marginLeft: 0,
      borderLeft: "solid 1px #ccc",
      height: "100%",
      alignItems: "center"
    },
    searchBox: {
      padding: "2.4rem"
    },
    searchInput: {
      display: "flex"
    },
    flexs: {
      display: "flex"
    },
    formControl: {
      padding: 2
    },
    errorMessage: {
      color: theme.palette.error.light,
      lineHeight: "18px",
      marginTop: 4,
      fontSize: 12
    },
    successMessage: {
      color: theme.palette.success.main
    },
    selectField: {
      height: "36px",
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem",
        color: theme.palette.grey[800]
      }
    },
    required: {
      color: theme.palette.error.main,
      "& :after": {
        content: "*"
      }
    },
    dialog: {
      width: "420px",
      height: "242px",
      padding: "32px 24px 32px 24px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px"
    },
    titles: {
      fontSize: "20px",
      fontWeight: 700
    },
    button: {
      alignSelf: "center",
      backgroundColor: "#009FB8",
      borderRadius: "4px",
      width: "315px",
      height: "48px",
      marginTop: "50px"
    },
    buttonTitle: {
      fontSize: "18px",
      color: "white"
    },
    priorityWrappers: {
      position: "relative",
      backgroundColor: "#F4F7FE",
      padding: "8px 16px",
      borderRadius: 8,
      marginBottom: 16,
      "&:hover": {
        border: "1px solid #009FB8",
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
      }
    },
    priorityHeaders: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    removeButtons: {
      padding: "10px",
      cursor: "pointer",
      "& img": {
        height: "22px",
        width: "18px"
      }
    },
    addPrioritys: {
      display: "flex",
      color: "#009FB8",
      fontSize: 14,
      fontWeight: 400,
      cursor: "pointer",
      width: "144px",
      height: "40px",
      padding: "8px 19px",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "4px",
      border: "1px solid var(--ci-colors-teal, #009FB8)",
      background: "var(--grayscale-white, #FFF)",
      marginLeft: "100px",
      marginRight: 10
    },
    paddingTop0: {
      paddingTop: "0px !important"
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5,
      fontSize: 12
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    },
    snackBarWrapper: {
      width: 780
    }
  }),
  { name: "SoldToSearchBar" }
);
export default useStyles;
